import { createContext } from 'react';
/**
 * this function generates a default fetch root context
 * @return {React.Context} - the default fetch root context
 */

export function createRootContext() {
  return /*#__PURE__*/createContext({
    fetcher: window.fetch
  });
}
export default createRootContext();